import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Icon } from "../Icon";
import { useAuth } from "../auth";
import { PageHero, useSeo } from "../ui";

/* 토큰이 주소에 있으면 '새 비밀번호 정하기', 없으면 '재설정 메일 요청' 화면이다. */
export default function PasswordReset() {
  useSeo({ title: "비밀번호 찾기 | I.META", path: "/password-reset", noindex: true });

  const [params] = useSearchParams();
  const token = params.get("token");
  const { call } = useAuth();

  const [email, setEmail] = useState("");
  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  async function requestMail(e) {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await call("/password/request", { method: "POST", body: JSON.stringify({ email: email.trim() }) });
      setDone(true);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }

  async function confirmReset(e) {
    e.preventDefault();
    if (pw.a !== pw.b) { setError("비밀번호가 서로 다릅니다."); return; }
    if (pw.a.length < 8) { setError("비밀번호는 8자 이상으로 정해주세요."); return; }
    setBusy(true); setError("");
    try {
      await call("/password/reset", { method: "POST", body: JSON.stringify({ token, password: pw.a }) });
      setDone(true);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }

  if (done) {
    return (
      <PageHero
        kicker="PASSWORD"
        title={token ? "비밀번호가 변경되었습니다" : "메일을 보내드렸습니다"}
        desc={
          token
            ? "새 비밀번호로 로그인해주세요. 기존에 로그인되어 있던 기기는 모두 로그아웃됩니다."
            : "가입된 이메일이라면 재설정 링크를 보내드렸습니다. 메일이 보이지 않으면 스팸함도 확인해주세요."
        }
      >
        <div className="hero__actions">
          <Link to="/login" className="btn btn--primary">
            로그인하기 <Icon.ArrowRight width="16" height="16" aria-hidden="true" focusable="false" />
          </Link>
        </div>
      </PageHero>
    );
  }

  return (
    <>
      <PageHero
        kicker="PASSWORD"
        title={token ? "새 비밀번호 정하기" : "비밀번호 찾기"}
        desc={
          token
            ? "새로 쓰실 비밀번호를 입력해주세요."
            : "가입하신 이메일 주소를 입력하시면 재설정 링크를 보내드립니다."
        }
      />

      <section className="section section--tight">
        <form className="auth-card form" onSubmit={token ? confirmReset : requestMail} noValidate>
          {token ? (
            <>
              <div className="form__field">
                <label className="form__label" htmlFor="pr-a">새 비밀번호</label>
                <input id="pr-a" className="form__input" type="password" required minLength={8}
                  autoComplete="new-password" value={pw.a} onChange={(e) => setPw((p) => ({ ...p, a: e.target.value }))} disabled={busy} />
              </div>
              <div className="form__field">
                <label className="form__label" htmlFor="pr-b">새 비밀번호 확인</label>
                <input id="pr-b" className="form__input" type="password" required minLength={8}
                  autoComplete="new-password" value={pw.b} onChange={(e) => setPw((p) => ({ ...p, b: e.target.value }))} disabled={busy} />
              </div>
            </>
          ) : (
            <div className="form__field">
              <label className="form__label" htmlFor="pr-email">이메일</label>
              <input id="pr-email" className="form__input" type="email" required maxLength={200}
                autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} disabled={busy} />
            </div>
          )}

          {error && <p className="form__error" role="alert">{error}</p>}

          <button type="submit" className="btn btn--primary btn--block" disabled={busy}>
            {busy ? "처리 중…" : token ? "비밀번호 변경" : "재설정 메일 받기"}
          </button>

          <p className="form__note"><Link to="/login">로그인으로 돌아가기</Link></p>
        </form>
      </section>
    </>
  );
}
